import React, { useRef, useEffect, useState } from 'react';
import { ReactComponent as SearchIcon } from '../../assets/image/search.svg';
import { ReactComponent as FilterIcon } from '../../assets/image/filter.svg';
import './KeywordSearchBar.scss';

const GROUP_LABELS = {
  region: 'Région',
  ville: 'Ville',
  activite: 'Activité',
  artiste: 'Artiste',
};

const KeywordSearchBar = ({
  value,
  onChange,
  onSubmitKeyword,
  suggestions,
  onPickStructured,
  label = 'Trouver un événement',
  placeholder = 'Mot-clé, nom d\'artiste, activité, ville, etc.',
}) => {
  const [open, setOpen] = useState(false);
  const [activeIndex, setActiveIndex] = useState(-1);
  const wrapRef = useRef(null);

  useEffect(() => {
    const handleDocMouseDown = (e) => {
      if (wrapRef.current && !wrapRef.current.contains(e.target)) {
        setOpen(false);
        setActiveIndex(-1);
      }
    };
    document.addEventListener('mousedown', handleDocMouseDown);
    return () => document.removeEventListener('mousedown', handleDocMouseDown);
  }, []);

  const showDropdown = open && value.trim().length > 0 && suggestions.length > 0;

  const handleKeyDown = (e) => {
    if (!showDropdown) {
      if (e.key === 'Enter') {
        e.preventDefault();
        onSubmitKeyword();
      }
      return;
    }
    if (e.key === 'ArrowDown') {
      e.preventDefault();
      setActiveIndex((i) => Math.min(i + 1, suggestions.length - 1));
    } else if (e.key === 'ArrowUp') {
      e.preventDefault();
      setActiveIndex((i) => Math.max(i - 1, 0));
    } else if (e.key === 'Enter') {
      e.preventDefault();
      if (activeIndex >= 0 && suggestions[activeIndex]) {
        onPickStructured(suggestions[activeIndex]);
        setOpen(false);
        setActiveIndex(-1);
      } else {
        onSubmitKeyword();
      }
    } else if (e.key === 'Escape') {
      setOpen(false);
      setActiveIndex(-1);
    }
  };

  return (
    <div className="keywordSearchBar" ref={wrapRef}>
      <div className="keywordSearchBar__row">
        <div className="keywordSearchBar__fieldCol">
          <label className="keywordSearchBar__label" htmlFor="programmation-keyword">
            {label}
          </label>
          <div className="keywordSearchBar__inputWrap">
            <input
              id="programmation-keyword"
              type="text"
              className="keywordSearchBar__input"
              value={value}
              onChange={(e) => {
                onChange(e.target.value);
                setOpen(true);
                setActiveIndex(-1);
              }}
              onFocus={() => {
                if (value.trim()) setOpen(true);
              }}
              onKeyDown={handleKeyDown}
              placeholder={placeholder}
              autoComplete="off"
              aria-autocomplete="list"
              aria-controls={showDropdown ? 'programmation-keyword-suggestions' : undefined}
            />
            <span className="keywordSearchBar__searchIcon" aria-hidden>
              <SearchIcon />
            </span>
            {showDropdown ? (
              <ul id="programmation-keyword-suggestions" className="keywordSearchBar__suggestions" role="listbox">
                {suggestions.map((s, idx) => (
                  <li
                    key={`${s.source}-${String(s.value)}-${idx}`}
                    role="option"
                    aria-selected={idx === activeIndex}
                    className={idx === activeIndex ? 'is-active' : ''}
                    onMouseDown={(ev) => {
                      ev.preventDefault();
                      onPickStructured(s);
                      setOpen(false);
                      setActiveIndex(-1);
                    }}
                    onMouseEnter={() => setActiveIndex(idx)}
                  >
                    <span className="keywordSearchBar__suggestionGroup">{GROUP_LABELS[s.source]}</span>
                    <span className="keywordSearchBar__suggestionLabel">{s.label}</span>
                  </li>
                ))}
              </ul>
            ) : null}
          </div>
        </div>
        <button type="button" className="keywordSearchBar__submitBtn" onClick={() => onSubmitKeyword()}>
          Rechercher
        </button>
      </div>
    </div>
  );
};

export default KeywordSearchBar;
